import React, {useContext, useEffect} from "react";
import {AuthContext} from "../../context/authContext";
import {TITLE, VIDEO_DESCRIPTION, VIDEO_TITLE} from "../../config/config";
import TabbedContents from "../common/TabbedContents";
import {VideoProvider} from "../../context/videoContext";
import Body from "../common/Body";
import NormalMobile from "./tabs/NormalMobile";
import VipMobile from "./tabs/VipMobile";
import FriendsMobile from "./tabs/FriendsMobile";
import {VideoItemContext, VideoItemProvider} from "../../context/videoItemContext";

const MainContent = ({initialTab = null}) => {
	useEffect(() => {
		import("../../assets/video_mobile.css");

		return () => {
			const link = document.querySelector('link[href="../../assets/video_mobile.css"]');
			if (link) {
				link.parentNode.removeChild(link);
			}
		};
	}, []);

	const {visitor} = useContext(AuthContext);

	const {video} = useContext(VideoItemContext);

	const tabContents = [];
	if (visitor && visitor.can_view_videos) {
		tabContents.push({
			label: 'Videos',
			content: <NormalMobile initialVideo={video ? video : null} />
		});

		tabContents.push({
			label: 'Friends',
			content: <FriendsMobile initialVideo={video ? video : null} />
		});
	}

	if (visitor && visitor.can_view_videos_vip) {
		tabContents.push({
			label: 'VIP',
			content: <VipMobile initialVideo={video ? video : null} />
		});
	}

	let initialTabIndex = null;
	if (initialTab === 'normal') {
		initialTabIndex = 0;
	} else if (initialTab === 'friends') {
		initialTabIndex = 1;
	} else if (initialTab === 'vip') {
		initialTabIndex = 2;
	}

	useEffect(() => {
		document.title = `${VIDEO_TITLE} | ${TITLE}`;
		document.querySelector('meta[name="description"]').setAttribute("content", VIDEO_DESCRIPTION);
	});

	if (visitor && visitor.can_view_videos) {
		return (
			<div className="video-container w-full h-full">
				<TabbedContents tabContents={tabContents} hasBorder={false} initialIndex={initialTabIndex} />
			</div>
		);
	} else {
		return (
			<div className="p-4 text-white text-xl text-center">
				Vui lòng đăng nhập để xem videos
			</div>
		);
	}
}

const VideoIndexMobile = ({initialTab = null}) => {
	return (
		<VideoProvider><VideoItemProvider>
			<Body mainContent={<MainContent initialTab={initialTab} />} />
		</VideoItemProvider></VideoProvider>
	);
}

export default VideoIndexMobile;